"use client";

import { SessionProvider } from "next-auth/react";

const ProviderAuth = ({ children, session }) => (
  <SessionProvider session={session}>{children}</SessionProvider>
);

export default ProviderAuth;